import { Box, Typography } from "@mui/material";
import logo from '../betflaglive-blu.svg';

const Footer = () => {
    return (
        <Box sx={{ bgcolor: "background.paper", p: 6 }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 6,
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'center', width: { xs: '100%', sm: 'auto' } }}>
                    <img src={logo} alt="logo" style={{ width: '100%', maxWidth: 200 }} />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: { xs: 'center', sm: 'flex-start' },
                        gap: 2,
                    }}
                >
                    <Typography variant="p" color="text.secondary" align="center">Questo sito non rappresenta una testata giornalistica in quanto viene aggiornato senza alcuna periodicità.</Typography>
                    <Typography variant="caption" color="text.secondary" align="center">Copyright © {new Date().getFullYear()} Betflaglive.it</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary' }}>
                        <svg className="ai-disclaimer-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66.654 28.454" style={{ height: '12px', flexShrink: 0 }}>
                            <text style={{ fill: 'currentColor', fontFamily: 'Arial', fontSize: '32px', fontWeight: 800, letterSpacing: '-1.2px', stroke: 'currentColor', strokeOpacity: 0.3, whiteSpace: 'pre' }} transform="matrix(1, 0, 0.000645, 1, 1.522835, -1)" x="26.508" y="26.392">AI</text>
                            <path d="M 13.95 4.424 C 13.95 9.644 18.18 13.864 23.39 13.864 C 18.17 13.864 13.95 18.094 13.95 23.304 C 13.95 18.084 9.72 13.864 4.51 13.864 C 9.73 13.864 13.95 9.634 13.95 4.424 Z" fill="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" style={{ stroke: 'currentColor', strokeOpacity: 0.3 }}></path>
                        </svg>
                        <Typography variant="caption" color="text.secondary" align="center">Alcune immagini sono state realizzate con il supporto dell'intelligenza artificiale.</Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
};

export default Footer;